import { render } from "./Indexcopy.vue?vue&type=template&id=36e7522c"
import script from "./Indexcopy.vue?vue&type=script&lang=js"
export * from "./Indexcopy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__